var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoupanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 30,
    viewBox: "0 0 50 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5018 0.963379H6.32849C3.12782 0.963379 0.524414 3.32364 0.524414 6.22489V24.285C0.524414 27.1862 3.12782 29.5465 6.32849 29.5465H43.5014C46.7011 29.5465 49.3049 27.1862 49.3049 24.285V6.22489C49.3049 3.32364 46.7011 0.963379 43.5018 0.963379ZM46.3211 24.285C46.3211 25.5407 45.0554 26.5627 43.5014 26.5627H6.32849C4.77335 26.5627 3.50822 25.5407 3.50822 24.285V6.22489C3.50822 4.96917 4.77335 3.94718 6.32849 3.94718H43.5014C45.0556 3.94718 46.3211 4.96917 46.3211 6.22489V24.285Z",
    fill: "#136FB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.768 11.4033H13.7842V13.9714H16.768V11.4033Z",
    fill: "#136FB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.768 21.6748H13.7842V24.2429H16.768V21.6748Z",
    fill: "#136FB2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.768 6.26709H13.7842V8.8352H16.768V6.26709Z",
    fill: "#136FB2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.768 16.5396H13.7842V19.1071H16.768V16.5396Z",
    fill: "#136FB2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3339 11.1614C30.3339 8.83309 28.4009 6.92383 26.0954 6.92383C23.7671 6.92383 21.8574 8.81015 21.8574 11.1614C21.8574 13.5369 23.7675 15.3993 26.0954 15.3993C28.4009 15.3993 30.3339 13.5136 30.3339 11.1614ZM24.2559 11.1614C24.2559 10.1369 25.0944 9.32232 26.095 9.32232C27.0956 9.32232 27.9341 10.1374 27.9341 11.1614C27.9341 12.1863 27.0956 13.0008 26.095 13.0008C25.0944 13.0008 24.2559 12.1857 24.2559 11.1614Z",
    fill: "#136FB2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0328 15.2603C34.7045 15.2519 32.7874 17.1317 32.7783 19.4833C32.7703 21.8579 34.6735 23.7283 37.0024 23.7374C39.3083 23.7458 41.2468 21.8656 41.2558 19.5143C41.2639 17.1852 39.3383 15.2681 37.0328 15.2603ZM37.0169 21.3383C36.0163 21.3383 35.1784 20.5222 35.1784 19.4982C35.1784 18.4733 36.0169 17.6588 37.0169 17.6588C38.0185 17.6588 38.8563 18.4739 38.8563 19.4982C38.8569 20.5228 38.0185 21.3383 37.0169 21.3383Z",
    fill: "#136FB2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6682 6.25784L25.6719 23.1719L28.3063 24.5731L37.3026 7.65903L34.6682 6.25784Z",
    fill: "#136FB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupanIcon);
export default __webpack_public_path__ + "static/media/coupan_icon.5df5f8cffae826f5d9077f0fc0ff46d8.svg";
export { ForwardRef as ReactComponent };